import produce from 'immer';
import {
  UPLOAD_IMAGE_START,
  UPLOAD_IMAGE_SUCCESS,
  UPLOAD_IMAGE_FAILED,
  REMOVE_UPLOADED_IMAGE,
  SAVE_REQUEST_SKU_EMAIL_DATA_START,
  SAVE_REQUEST_SKU_EMAIL_DATA_SUCCESS,
  SAVE_REQUEST_SKU_EMAIL_DATA_FAILED,
  SAVE_REQUEST_PROMOTION_EMAIL_DATA_START,
  SAVE_REQUEST_PROMOTION_EMAIL_DATA_SUCCESS,
  SAVE_REQUEST_PROMOTION_EMAIL_DATA_FAILED,
  SAVE_DATA_MAPPING_REQUEST_SKU_EMAIL_DATA_START,
  SAVE_DATA_MAPPING_REQUEST_SKU_EMAIL_DATA_SUCCESS,
  SAVE_DATA_MAPPING_REQUEST_SKU_EMAIL_DATA_FAILED,
} from '../actions/email';


const initialState = {
  uploadedImagesUrls: [],
  imageLoading: false,
  imageError: false,
  saveEmailDataLoading: false,
  saveDataMappingRequestSKUEmailDataLoading: false
};


const formReducer = produce((state: IEmailState = initialState, action) => {
  switch (action.type) {
    case UPLOAD_IMAGE_START: {
      state.imageLoading = true;
      break;
    }

    case UPLOAD_IMAGE_SUCCESS: {
      const {data} = action;
      state.uploadedImagesUrls = [...state.uploadedImagesUrls, data.imageUrl];
      state.imageLoading = false;
      break;
    }

    case UPLOAD_IMAGE_FAILED: {
      state.imageLoading = false;
      state.imageError = true;
      break;
    }

    case REMOVE_UPLOADED_IMAGE: {
      const {index} = action;
      state.uploadedImagesUrls.splice(index, 1);
      break;
    }

    case SAVE_REQUEST_SKU_EMAIL_DATA_START: {
      state.saveEmailDataLoading = true;
      break;
    }

    case SAVE_REQUEST_SKU_EMAIL_DATA_SUCCESS: {
      state.uploadedImagesUrls = [];
      state.saveEmailDataLoading = false;
      break;
    }

    case SAVE_REQUEST_SKU_EMAIL_DATA_FAILED: {
      state.saveEmailDataLoading = false;
      break;
    }

    case SAVE_REQUEST_PROMOTION_EMAIL_DATA_START: {
      state.saveEmailDataLoading = true;
      break;
    }

    case SAVE_REQUEST_PROMOTION_EMAIL_DATA_SUCCESS: {
      state.saveEmailDataLoading = false;
      break;
    }

    case SAVE_REQUEST_PROMOTION_EMAIL_DATA_FAILED: {
      state.saveEmailDataLoading = false;
      break;
    }

    case SAVE_DATA_MAPPING_REQUEST_SKU_EMAIL_DATA_START: {
      state.saveDataMappingRequestSKUEmailDataLoading = true;
      break;
    }

    case SAVE_DATA_MAPPING_REQUEST_SKU_EMAIL_DATA_SUCCESS: {
      state.saveDataMappingRequestSKUEmailDataLoading = false;
      break;
    }

    case SAVE_DATA_MAPPING_REQUEST_SKU_EMAIL_DATA_FAILED: {
      state.saveDataMappingRequestSKUEmailDataLoading = false;
      break;
    }

    default:
      break;
  }
}, initialState);

export default formReducer;
